import isEqual from 'lodash/isEqual';
import {useRef, useEffect} from 'react';

export default function useDeepMemoized<T extends object>(obj: T) {
  const prevObjRef = useRef(obj);
  const result = isEqual(obj, prevObjRef.current) ? prevObjRef.current : obj;
  useEffect(() => {
    prevObjRef.current = result;
  }, [result]);
  return result;
}
